import Route from '@ember/routing/route';

export default class AssessmentsRoute extends Route {}
